import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { AlertTriangle, Check } from "lucide-react";

export default function DeleteConfirm() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token");
  const [status, setStatus] = useState("idle"); // idle | processing | done | error
  const [err, setErr] = useState("");

  async function confirm() {
    if (!token) { setStatus("error"); setErr("Link non valido (token mancante)."); return; }
    setStatus("processing");
    try {
      await api.post("/me/delete-confirm", { token });
      try { localStorage.removeItem("token"); } catch {}
      setStatus("done");
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Link scaduto o già utilizzato.");
      setStatus("error");
    }
  }

  useEffect(() => { if (!token) { setStatus("error"); setErr("Token mancante nel link."); } }, [token]);

  return (
    <div className="max-w-md mx-auto px-4 md:px-8 py-16" data-testid="delete-confirm-page">
      <div className="card-soft p-8">
        {status === "idle" && (
          <>
            <div className="h-12 w-12 rounded-full bg-red-100 flex items-center justify-center mb-4 dark:bg-red-950/40">
              <AlertTriangle className="h-6 w-6 text-red-700 dark:text-red-300" />
            </div>
            <h1 className="font-display text-2xl font-medium">Confermi la cancellazione?</h1>
            <p className="text-sm text-zinc-600 mt-2 dark:text-zinc-400">
              Stai per cancellare definitivamente il tuo account Prenotoo. Le prenotazioni passate verranno anonimizzate per obblighi fiscali. L'azione è irreversibile.
            </p>
            <div className="flex gap-2 mt-6">
              <button onClick={() => nav("/")} className="btn-secondary h-11 flex-1" data-testid="delete-confirm-cancel">Annulla</button>
              <button onClick={confirm} className="h-11 flex-1 px-5 rounded-full text-sm font-medium bg-red-600 text-white hover:bg-red-700" data-testid="delete-confirm-ok">Sì, cancella</button>
            </div>
          </>
        )}
        {status === "processing" && <p className="text-sm text-zinc-600 dark:text-zinc-400">Cancellazione in corso…</p>}
        {status === "done" && (
          <>
            <div className="h-12 w-12 rounded-full bg-emerald-100 flex items-center justify-center mb-4 dark:bg-emerald-950/40">
              <Check className="h-6 w-6 text-emerald-700 dark:text-emerald-300" />
            </div>
            <h1 className="font-display text-2xl font-medium">Account cancellato</h1>
            <p className="text-sm text-zinc-600 mt-2 dark:text-zinc-400">Il tuo account è stato rimosso. Grazie per aver usato Prenotoo.</p>
            <button onClick={() => nav("/")} className="btn-accent h-11 mt-6" data-testid="delete-done-home">Torna alla home</button>
          </>
        )}
        {status === "error" && (
          <>
            <div className="h-12 w-12 rounded-full bg-red-100 flex items-center justify-center mb-4 dark:bg-red-950/40">
              <AlertTriangle className="h-6 w-6 text-red-700 dark:text-red-300" />
            </div>
            <h1 className="font-display text-2xl font-medium">Link non valido</h1>
            <p className="text-sm text-zinc-600 mt-2 dark:text-zinc-400" data-testid="delete-error-msg">{err}</p>
            <button onClick={() => nav("/me")} className="btn-secondary h-11 mt-6">Torna al profilo</button>
          </>
        )}
      </div>
    </div>
  );
}
